import React from "react";
import { useSelector } from "react-redux";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
 

const CollectionPieChart = () => {
  const url = "api/v2/dashboard/fetch-dashboard";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, value, color } = payload[0].payload;
      return (
        <div className="p-2 rounded-md shadow-md bg-white border border-gray-200">
          <div className="flex items-center gap-2 mb-1">
            <span className="w-3 h-3" style={{ backgroundColor: color }} />
            <span className="font-medium text-gray-800">{name}</span>
          </div>
          <div className="text-sm text-gray-600">
            KSh {value.toLocaleString()}
          </div>
        </div>
      );
    }
    return null;
  };
  return (
    <div className="rounded-[.75rem] bg-white p-[1.25rem] w-full">
      <div className="ndovu-gradient-title text-[1rem] font-[400] leading-6 font-lexendS ">
        Collection Types
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data?.collectionChannels}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={100}
            dataKey="value"
            nameKey="name"
          >
            {data?.collectionChannels?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CollectionPieChart;
